var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStorePick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#DBDBDB",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3657_48572",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "#FC1D56"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3657_48572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5379 13.4625L5.68164 11.4938C5.51914 11.4313 5.40039 11.3344 5.32539 11.2031C5.25039 11.0719 5.21289 10.9375 5.21289 10.8C5.21289 10.6625 5.25352 10.5281 5.33477 10.3969C5.41602 10.2656 5.53789 10.1688 5.70039 10.1063L17.2129 5.83127C17.3629 5.76877 17.5066 5.75627 17.6441 5.79377C17.7816 5.83127 17.9004 5.90002 18.0004 6.00002C18.1004 6.10002 18.1691 6.21877 18.2066 6.35627C18.2441 6.49377 18.2316 6.63752 18.1691 6.78752L13.8941 18.3C13.8316 18.4625 13.7348 18.5844 13.6035 18.6656C13.4723 18.7469 13.3379 18.7875 13.2004 18.7875C13.0629 18.7875 12.9285 18.75 12.7973 18.675C12.666 18.6 12.5691 18.4813 12.5066 18.3188L10.5379 13.4625Z",
    fill: "#FF4B51"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorePick);
export default __webpack_public_path__ + "static/media/storePick.26195976dff72c1a02dc92326ba30eb8.svg";
export { ForwardRef as ReactComponent };